import * as l from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from '../globals';
class Goal extends l.EngineObject {
    constructor(pos) {
        // Using tile 4 for goal, assuming it's available in ASSETS tilesheet
        const goalTile = l.tile(4, tilesize, tilesheets.ASSETS);
        super(pos, l.vec2(1, 1), goalTile, 0, l.hsl(0.3, 1, 0.5), 1); // Greenish color
        this.collideTiles = false;
        this.collideSolidObjects = false;
        this.mass = 0;
        this.reached = false;
    }
    update() {
        super.update();
        if (!this.reached) {
            // Check collision with Rex
            if (Globals.rex && this.pos.distance(Globals.rex.pos) < 1) {
                this.reached = true;
            }
            // Check collision with Chip
            if (Globals.chip && this.pos.distance(Globals.chip.pos) < 1) {
                this.reached = true;
            }
        }
    }
    render() {
        super.render();
    }
}
export default Goal;
